import type { LedgerSummaryResponse } from "./types";

export type TradeStreakSummary = {
  type: "win" | "loss" | "flat";
  length: number;
  label: string;
};

function isReduceOnlyClose(row: { reduceOnly?: boolean; closedPnl?: number }) {
  if (row.reduceOnly === true) return true;
  if (row.reduceOnly === false) return false;
  const pnl = row.closedPnl;
  return pnl != null && Number.isFinite(Number(pnl));
}

function netPnl(row: { closedPnl?: number; fees?: number }) {
  const pnl = Number(row.closedPnl ?? 0);
  const fees = Number(row.fees ?? 0);
  return pnl - fees;
}

export function computeRoundTripStreakFromLedger(
  ledger?: LedgerSummaryResponse | null,
): TradeStreakSummary | null {
  const rows = ledger?.recentExecutions;
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const ordered = [...rows].sort((a, b) => {
    const aTime = new Date(a.reportedAt ?? 0).getTime();
    const bTime = new Date(b.reportedAt ?? 0).getTime();
    return (Number.isFinite(aTime) ? aTime : 0) - (Number.isFinite(bTime) ? bTime : 0);
  });
  const outcomes: Array<"win" | "loss" | "flat"> = [];
  for (const row of ordered) {
    if (!isReduceOnlyClose(row)) continue;
    const net = netPnl(row);
    if (net > 0) outcomes.push("win");
    else if (net < 0) outcomes.push("loss");
    else outcomes.push("flat");
  }
  if (outcomes.length === 0) return null;
  const last = outcomes[outcomes.length - 1];
  let length = 0;
  for (let i = outcomes.length - 1; i >= 0; i -= 1) {
    if (outcomes[i] !== last) break;
    length += 1;
  }
  if (last === "flat") {
    return { type: "flat", length, label: `무승부 ${length} (청산 RT)` };
  }
  if (last === "win") {
    return { type: "win", length, label: `연승 ${length} (청산 RT)` };
  }
  return { type: "loss", length, label: `연패 ${length} (청산 RT)` };
}
